"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TranslationsFields = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const form_panel_1 = require("../../composite/form/fields/form-panel");
const form_select_1 = require("../../composite/form/fields/form-select");
const translations_api_1 = require("./translations-api");
const form_file_field_1 = require("../../composite/form/fields/form-file-field");
function TranslationsFields() {
    const languages = translations_api_1.useLanguages();
    return (react_1.default.createElement(form_panel_1.FormPanel, { label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS_TRANSLATIONS_PANEL_TITLE", defaultMessage: "P\u0159eklad" }) },
        react_1.default.createElement(form_select_1.FormSelect, { name: "language", required: true, label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS_TRANSLATIONS_FIELD_LANGUAGE", defaultMessage: "Jazyk" }), source: languages, tooltipMapper: (o) => o.name, valueIsId: true }),
        react_1.default.createElement(form_file_field_1.FormFileField, { name: "content", required: true, label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS_TRANSLATIONS_FIELD_CONTENT", defaultMessage: "Soubor" }) })));
}
exports.TranslationsFields = TranslationsFields;
//# sourceMappingURL=translations-fields.js.map